module.exports = __webpack_public_path__ + "img/real-betis-logo-icon.4ff36a11.png";